import { createReducer, on } from '@ngrx/store';
import { setClient } from './client.actions';
import { IClientState } from './client.models';


export const initialState: IClientState = {};

export const clientReducers = createReducer(
    initialState,

    on(setClient, (state, { clientData }) => clientData),

);